import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SubVisual from "../../../components/SubVisual";
import { noticeLists } from "../../../data/notice";
import subVisualNotice from "../../../assets/subVisual/subVisualNotice.png";
import * as S from "./styled";
import Aos from "aos";
import Icon from "../../../components/Icon";
import { Helmet } from "react-helmet-async";

const NoticeDetail = () => {
  const { id } = useParams();
  const [notice, setNotice] = useState<any>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const getNoticeById = (id: any) =>
        noticeLists.find((notice) => notice.id === id);

      setNotice(getNoticeById(id));
    } else {
      navigate("/notice");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const renderingMessage = (message: string) => {
    return message.split("\n").map((line, index) => {
      // URL 감지 정규식
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = line.split(urlRegex);

      return (
        <span key={index}>
          {parts.map((part, i) =>
            urlRegex.test(part) ? (
              <a
                key={i}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                {part}
              </a>
            ) : (
              part
            )
          )}
          <br />
        </span>
      );
    });
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://ipdiakorea.com" />
        <meta
          property="og:image"
          content="http://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.NoticeDetailContainer>
        <SubVisual
          src={subVisualNotice}
          title="공지사항"
          subTitle="협회 소식"
        />
        {notice && (
          <S.NoticeDetailWrapper>
            <div className="inner">
              <S.NoticeDetailWrap>
                <S.NoticeDetailTitleWrap
                  data-aos="fade"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <h6>{notice.title}</h6>
                  <p>{notice.date}</p>
                </S.NoticeDetailTitleWrap>
                <S.NoticeContentsWrap
                  data-aos="fade"
                  data-aos-duration={800}
                  data-aos-delay={200}
                  data-aos-easing="linear"
                >
                  {notice.images.length > 0 && (
                    <div className="img-wrap">
                      {notice.images.map((image: any, index: number) => (
                        <Icon key={index}>
                          <img src={image} alt="img" />
                        </Icon>
                      ))}
                    </div>
                  )}

                  {notice.detailText && (
                    <div className="text-wrap">
                      {renderingMessage(notice.detailText)}
                    </div>
                  )}
                </S.NoticeContentsWrap>
              </S.NoticeDetailWrap>
            </div>
            <S.NoticeButtonWrap
              data-aos="fade"
              data-aos-duration={600}
              data-aos-delay={400}
              data-aos-easing="linear"
            >
              <p onClick={() => navigate("/notice")}>목록으로</p>
            </S.NoticeButtonWrap>
          </S.NoticeDetailWrapper>
        )}
      </S.NoticeDetailContainer>
    </>
  );
};

export default NoticeDetail;
